import { STATE_INITIAL } from 'Store/commonActions';

import { QUEUE_MAIN } from './constants';
import type { RecsState } from './types';

const initialState: RecsState = {
  recs: {
    chatBubbleIntro: false, // persist
    likedRecPhotos: [],
    onePreviousRec: null,
    previouslySwiped: [], // persist
    previousRec: null,
    status: STATE_INITIAL,
    queues: {
      [QUEUE_MAIN]: [],
    },
    activeQueue: QUEUE_MAIN,
    error: false,
  },
  session: {
    outOfLikes: false,
    outOfRecs: false,
    outOfSuperlikes: false,
  },
  counts: {
    persistedSwipeCount: 0, // persist
    rightSwipeCount: 0,
    superlikeSwipeCount: 0, // persist
    swipeCount: 0,
  },
  matches: {
    recentlyMatchedMatchIds: [],
  },
  superlike: {
    showStarAnimation: false,
    resets: 0,
    upsellRecId: '',
  },
};

export default initialState;
